// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34ugf","clinicsSelect":"styles_clinicsSelect__1_5gy"};